<template>
    <div class="centrifuge-details-container">
      <roof-search :middleContent="false" :rightContent="false" :placeholder="true" v-show="isShowNav"></roof-search>
      <!-- 返回列表 -->
      <div class="return-button" @click="returnBack">
            <i class="iconfont icon-youjiantou"></i>
            <span class="span">返回列表</span>
      </div>
      <!-- 轮播 -->
      <div class="swiper-content">
        <swiper class="swiper-container" :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
          <swiper-slide v-for="(item,index) in detailsData.product_img" :key="index">
<!--            <img :src="cdnUrl+item" class="slide-img" alt="">-->
            <van-image fit="cover" :src="cdnUrl+item" class="slide-img" @click="previewImage(item)"/>
          </swiper-slide>
        </swiper>
        <div class="mask-title">{{detailsData.product_title}}</div>
      </div>
     
      <!-- 详情 -->
      <div class="centrifuge-particulars">
        <div class="item">
        <div class="nav-title">配置详情</div>
        <div class="content-details">
            <div class="content" v-html="detailsData.product_desc"></div>
        </div>
        </div>
      </div>
      <div class="line-top"></div>
       <!-- 离心机套装 -->
      <div class="centrifuge-intro product-margin">
        <div class="nav-title">查询货号</div>
        <div class="intro-content">
<!--          <div class="info" :class="clickMore?'':'van-multi-ellipsis&#45;&#45;l2'" v-html="detailsObj.jianjie"></div>-->
          <!-- <div class="info" :class="clickMore?'':'van-multi-ellipsis--l2'" v-html="detailsData.product_recommand"></div> -->
          <div class="info" v-html="detailsData.product_recommand"></div>

          <!-- <div class="info" v-html="detailsData.product_recommand"></div> -->
          <!-- <div class="bottom-btn" @click="moreContent" v-show="introLength >= 50">
                {{clickMore?'收起':'展开全部'}}
                <i class="iconfont icon-youjiantou" :class="clickMore?'rotate-icon':''"></i>
          </div> -->
        </div>
      </div>
    </div>
</template>

<script>

import 'swiper/dist/css/swiper.css'
import details from '../product/mixins/details'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import roofSearch from '@/components/roof-search'
import { ImagePreview } from 'vant'
import { getnewProductDetail } from '@/api/centrifuge'
import { wxShare } from '@/libs/wxjssdk'
let vm = null

export default {
    mixins: [details],
    components: {
        roofSearch,
        swiper,
        swiperSlide
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    data () {
        return {
            id: '', // 产品id
            dp: {},
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 1,
                centeredSlides: true,
                loop: true,
                autoplay: false, // 自动切换
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.btn-next',
                    prevEl: '.btn-prev'
                },
                on: {
                    tap () {
                        const { realIndex } = this
                        vm.handleClickSlide(realIndex)
                    },
                    slideChange () {
                        vm.slideChange(this.realIndex)
                    }
                }
            },
            sliderList: [],
            currentSliderIndex: 0, // 当前slider图片下标
            clickMore: false, // 是否单击了更多
            detailsData: {
                product_title: '',
                product_desc: '',
                product_img: [],
                product_recommand: ''
            }
        }
    },
    created () {
        // console.log('打印vuex用户信息', this.$store.state.user)
        vm = this
        var query = this.$route.query
        this.id = query.id || ''
        this.isShowNav = query.isShowNav || false
        // this.testing = this.$store.state.user.testing
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        this.getProductDetailsPort()
    },
    mounted () {
    },
    methods: {
        sharePage () {
            const params = {
                title: this.detailsData.product_title, // 分享标题
                desc: '', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            document.title = this.detailsData.product_title || '产品详情'
            wxShare(params)
        },
        returnBack () {
            this.$router.push({
                name: 'centrifuge'
            })
        },
        // 隐藏video蒙版
        hideVideoMsg () {
            this.showVideo = false
            this.dp.pause()
            this.dp.fullScreen.cancel('web') // 退出全屏
        },
        handleClickSlide (realIndex) {
        // console.log('单击了', realIndex)
        },
        callback () {
            console.log('回调', 666)
        },
        slideChange (realIndex) {
            // console.log(666, realIndex, this.sliderList)
            this.currentSliderIndex = realIndex
        },
        // 单击了更多内容
        moreContent () {
            this.clickMore = !this.clickMore
        },
        // 单击 预览图片
        previewImage (url) {
            var images = []
            this.sliderList.map((val) => {
                images.push(this.cdnUrl + val)
            })
            ImagePreview({
                images: images,
                startPosition: this.currentSliderIndex
            })
        },
        /** 网络请求 **/
        // 根据id获取产品详情
        getProductDetailsPort () {
            var params = {
                id: this.id
            }
            getnewProductDetail(params).then(res => {
              // console.log('描述信息', res);
              // console.log('产品货号', res.data.product_recommand);
              // console.log('产品详情', res.data.product_desc);
                if (res.errCode === 0) {
                    this.$toast.clear()
                    var data = res.data
                    data.product_img = JSON.parse(data.product_img)
                    data.product_recommand = data.product_recommand.replace(/\n|\n\n|\r/g, '<br/>')
                    this.detailsData = data
                    this.sliderList = data.product_img
                    // console.log('打印数据', data, data.product_recommand)
                    // this.detailsObj = data
                    this.sharePage()
                    this.introLength = data.product_recommand.length
                }
            }).catch(err => {
                this.$toast.clear()
                this.$toast('获取详情数据失败')
                console.log('获取产品详情数据失败', err)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.centrifuge-details-container{
  padding-bottom: rem(60);
  background: #fff;
  .return-button{
      position: fixed;
      left: 0;
      top: rem(26);
      width: rem(90);
      height: rem(37);
      border-radius: 0 rem(30) rem(30) 0;
      z-index: 999;
      // background: #6DC6DC;
      background: #769DF9;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rem(13);
      color: #fff;
      .icon-youjiantou{
          transform: rotate(180deg);
      }
      .span{
          margin-left: rem(5);
      }
  }
  .swiper-content{
    width: 100%;
    height: rem(300);
    // padding: 0 rem(20);
    display: flex;
    align-items: center;
    position: relative;
    .mask-title{
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        width: 100%;
        min-height: rem(40);
        // background: rgba(0,0,0,0.7);
        background: rgba(118, 157, 249, 0.56);
        padding: rem(5) rem(20);
        color: #fff;
        display: flex;
        align-items: center;
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      .slide-img{
        width: 100%;
      }
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
    }
    .swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1);
    }
    .btn-prev,.btn-next{
      width: rem(18);
      height: rem(37);
      background: $base-color;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      outline: none;
      border: none;
      .icon-youjiantou{
        font-size: 20px;
        font-weight: bold;
      }
      .left{
        transform: rotate(-180deg);
      }
    }
    .btn-prev{
      margin-right: rem(7);
    }
    .btn-next{
      margin-left: rem(7);
    }
    .forbid-btn{
      background: #e4e0e0;
    }
  }
  .centrifuge-intro{
    .nav-title{
        width: rem(110);
        height: rem(30);
        // background: #6DC6DC;
        background: #769DF9;
        font-size: rem(14);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-right: rem(7);
        &:after{
            content: '';
            position: absolute;
            right: rem(-15);
            top: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 rem(15) rem(30) rem(15);
            border-color: transparent transparent #ffffff transparent;
        }
    }
    .intro-content{
      padding: rem(10) rem(20) rem(20);
      border-radius: 2px;
      overflow: hidden;
       /deep/a {
         font-size: 14px;
          color:#48C8DF;
        }
      .product-name{
        font-size: 15px;
        /*height: rem(35);*/
        line-height: rem(25);
      }
      .info{
        color: #333333;
        font-size: 12px;
        // line-height: rem(20);
        word-break: break-word;
      }
      .van-multi-ellipsis--l2{
        transition: all .2s;
      }
      .bottom-btn{
        width: rem(100);
        height: rem(28);
        display: block;
        margin: 0 auto;
        margin-top: rem(10);
        font-size: rem(12);
        background: none;
        color: #6DC6DC;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon-youjiantou{
            margin-left: rem(5);
            transform: rotate(90deg);
        }
        .rotate-icon{
             transform: rotate(-90deg);
        }
      }
    }
  }
  .centrifuge-particulars{
//   padding: 0 rem(20);
  margin-top: rem(20);
  padding-bottom: rem(10);
    //   .nav-title{
    //     width: rem(110);
    //     height: rem(30);
    //     // background: #6DC6DC;
    //     background: #769DF9;
    //     font-size: rem(14);
    //     color: #fff;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     position: relative;
    //     padding-right: rem(7);
    //     &:after{
    //         content: '';
    //         position: absolute;
    //         right: rem(-15);
    //         top: 0;
    //         width: 0;
    //         height: 0;
    //         border-style: solid;
    //         border-width: 0 rem(15) rem(30) rem(15);
    //         border-color: transparent transparent #ffffff transparent;
    //     }
    // }
    .nav-title{
        width: rem(110);
        height: rem(30);
        // background: #6DC6DC;
        background: #769DF9;
        font-size: rem(14);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-right: rem(7);
        &:after{
            content: '';
            position: absolute;
            right: rem(-15);
            top: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 rem(15) rem(30) rem(15);
            border-color: transparent transparent #ffffff transparent;
        }
    }
  .item{
    .h3-title{
      height: rem(45);
      line-height: rem(45);
      color: #333333;
      font-size: 15px;
      position: relative;
      display: flex;
      align-items: center;
      padding-left: rem(15);
      &:after{
        content: '';
        display: block;
        width: rem(8);
        height: rem(17);
        background: $base-color;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: rem(-8);
      }
    }
    .content-details{
       overflow: hidden;
       padding: 0 rem(20);
       color: #666;
       font-size: rem(12);
       line-height: rem(23);
      img{
        width: 100% !important;
        height: auto;
      }
      .content{
        margin-top: rem(20);
        // display: -webkit-box;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        /deep/a {
          color:#48C8DF;
        }
        img{
          width: 100% !important;
        }
      }
    }
  }
}
  .line-top {
    height: 8px;
    background-color: #F4F3F3;
  }
  .product-margin{
    margin-top: rem(10);
  }
  .tabs-container{
    .van-tab{
      font-size: 15px;
    }
    .van-tab--active{
      font-weight: bold;
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      /*border-width: 0;*/
      /*border-bottom: 1px solid ;*/
      border-top: 0 solid;
      border-bottom: 1px solid #eaeaea;
    }
  }
}
</style>
